import { render, staticRenderFns } from "./PracticeAreas.vue?vue&type=template&id=1df6e1e2&scoped=true"
import script from "./PracticeAreas.vue?vue&type=script&lang=js"
export * from "./PracticeAreas.vue?vue&type=script&lang=js"
import style0 from "./PracticeAreas.vue?vue&type=style&index=0&id=1df6e1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df6e1e2",
  null
  
)

export default component.exports